import React from "react";
import { IconProps } from "./IconProps";

const CaretCircleUpIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.375 1.875C7.79275 1.875 6.24603 2.34419 4.93044 3.22324C3.61485 4.10229 2.58947 5.35172 1.98397 6.81353C1.37847 8.27534 1.22004 9.88387 1.52872 11.4357C1.8374 12.9876 2.59933 14.413 3.71815 15.5319C4.83697 16.6507 6.26243 17.4126 7.81428 17.7213C9.36613 18.03 10.9747 17.8715 12.4365 17.266C13.8983 16.6605 15.1477 15.6352 16.0268 14.3196C16.9058 13.004 17.375 11.4572 17.375 9.875C17.3728 7.75395 16.5292 5.72042 15.0294 4.22062C13.5296 2.72081 11.496 1.87724 9.375 1.875ZM9.375 16.6442C8.03617 16.6442 6.72741 16.2472 5.61422 15.5034C4.50103 14.7596 3.6334 13.7024 3.12105 12.4655C2.6087 11.2286 2.47465 9.86749 2.73584 8.55439C2.99703 7.24129 3.64174 6.03512 4.58843 5.08843C5.53513 4.14174 6.74129 3.49703 8.05439 3.23584C9.36749 2.97465 10.7286 3.1087 11.9655 3.62105C13.2024 4.13339 14.2596 5.00102 15.0034 6.11422C15.7472 7.22741 16.1442 8.53617 16.1442 9.875C16.1422 11.6697 15.4284 13.3903 14.1593 14.6593C12.8903 15.9284 11.1697 16.6422 9.375 16.6442ZM12.8873 8.20884C12.9445 8.266 12.9899 8.33387 13.0209 8.40857C13.0519 8.48328 13.0678 8.56336 13.0678 8.64423C13.0678 8.7251 13.0519 8.80518 13.0209 8.87988C12.9899 8.95459 12.9445 9.02246 12.8873 9.07961L9.81039 12.1565C9.75323 12.2138 9.68536 12.2591 9.61066 12.2901C9.53595 12.3211 9.45587 12.337 9.375 12.337C9.29413 12.337 9.21405 12.3211 9.13935 12.2901C9.06464 12.2591 8.99677 12.2138 8.93962 12.1565L5.86269 9.07961C5.74722 8.96414 5.68235 8.80753 5.68235 8.64423C5.68235 8.48093 5.74722 8.32432 5.86269 8.20884C5.97817 8.09337 6.13478 8.0285 6.29808 8.0285C6.46138 8.0285 6.61799 8.09337 6.73346 8.20884L9.375 10.8512L12.0165 8.20884C12.0737 8.15163 12.1416 8.10624 12.2163 8.07527C12.291 8.0443 12.3711 8.02836 12.4519 8.02836C12.5328 8.02836 12.6129 8.0443 12.6876 8.07527C12.7623 8.10624 12.8302 8.15163 12.8873 8.20884Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2ZM10 17C6.14 17 3 13.86 3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17Z"
            fill={color}
          />
          <path
            d="M10.35 7.77C10.15 7.57 9.84 7.57 9.64 7.77L6.52 10.89C6.32 11.09 6.32 11.4 6.52 11.6C6.72 11.8 7.03 11.8 7.23 11.6L10 8.83L12.77 11.6C12.87 11.7 13 11.75 13.12 11.75C13.24 11.75 13.38 11.7 13.47 11.6C13.67 11.4 13.67 11.09 13.47 10.89L10.35 7.77Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3.25C13.4783 3.25 11.0132 3.99777 8.91648 5.39876C6.81975 6.79975 5.18555 8.79103 4.22053 11.1208C3.25552 13.4505 3.00302 16.0141 3.49499 18.4874C3.98695 20.9607 5.20127 23.2325 6.98439 25.0156C8.76751 26.7987 11.0393 28.0131 13.5126 28.505C15.9859 28.997 18.5495 28.7445 20.8792 27.7795C23.209 26.8144 25.2002 25.1802 26.6012 23.0835C28.0022 20.9868 28.75 18.5217 28.75 16C28.746 12.6197 27.4015 9.379 25.0112 6.98877C22.621 4.59854 19.3803 3.25397 16 3.25ZM16 27.25C13.775 27.25 11.5999 26.5902 9.74983 25.354C7.89978 24.1179 6.45784 22.3609 5.60635 20.3052C4.75487 18.2495 4.53208 15.9875 4.96616 13.8052C5.40025 11.6229 6.47171 9.61839 8.04505 8.04505C9.61839 6.47171 11.6229 5.40025 13.8052 4.96617C15.9875 4.53208 18.2495 4.75487 20.3052 5.60636C22.3609 6.45784 24.1179 7.89978 25.354 9.74984C26.5902 11.5999 27.25 13.775 27.25 16C27.2467 18.9827 26.0604 21.8422 23.9513 23.9513C21.8422 26.0604 18.9827 27.2467 16 27.25ZM21.53 17.47C21.6037 17.5387 21.6628 17.6215 21.7038 17.7135C21.7448 17.8055 21.7668 17.9048 21.7686 18.0055C21.7704 18.1062 21.7518 18.2062 21.7141 18.2996C21.6764 18.393 21.6203 18.4778 21.549 18.549C21.4778 18.6203 21.393 18.6764 21.2996 18.7141C21.2062 18.7518 21.1062 18.7704 21.0055 18.7686C20.9048 18.7668 20.8055 18.7448 20.7135 18.7038C20.6215 18.6628 20.5387 18.6037 20.47 18.53L16 14.0612L11.53 18.53C11.3878 18.6625 11.1998 18.7346 11.0055 18.7312C10.8112 18.7277 10.6258 18.649 10.4884 18.5116C10.351 18.3742 10.2723 18.1888 10.2688 17.9945C10.2654 17.8002 10.3375 17.6122 10.47 17.47L15.47 12.47C15.6106 12.3295 15.8012 12.2507 16 12.2507C16.1987 12.2507 16.3894 12.3295 16.53 12.47L21.53 17.47Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CaretCircleUpIcon;
